import { Record } from 'immutable'
import { PriceUnits } from './enums'

export interface IPrice {
  readonly amount: number
  readonly confidential: boolean
  readonly units: PriceUnits
}

const PriceRecord = Record({
  amount: 0,
  confidential: false,
  units: PriceUnits.Total,
})

export class Price extends PriceRecord implements IPrice {
  public static fromJS(initialState?: Partial<IPrice>) {
    return new Price(initialState)
  }

  public readonly amount: number
  public readonly confidential: boolean
  public readonly units: PriceUnits

  constructor(props?: Partial<Price>) {
    props ? super(props) : super()
  }
}
